import { DatePicker, Input, message } from "antd";
import dayjs from "dayjs";
import frFR from "antd/lib/date-picker/locale/fr_FR";
import "dayjs/locale/fr";

const CreateContractDate = ({ contract, setContract, finiteTerm = true, showHours = true }) => {
  const selectStartDate = (date) => {
    if (
      date &&
      contract.endDate &&
      date > new Date(contract.endDate)
    ) {
      message.error("La date de début doit être antérieure à la date de fin.");
    } else {
      setContract({ ...contract, startDate: date });
    }
  };

  const selectEndDate = (date) => {
    if (
      date &&
      contract.startDate &&
      date < new Date(contract.startDate)
    ) {
      message.error(
        "La date de fin doit être postérieure à la date de début.",
      );
    } else {
      setContract({ ...contract, endDate: date });
    }
  };

  
  return (
    <div>
      <p className="text-sm font-semibold text-left text-slate-900">Date de la mission</p>

      <div className={`my-4 grid gap-3 ${finiteTerm ? "sm:grid-cols-2" : ""}`}>
        <label className="block text-sm font-medium text-slate-700">
          Début de mission
          <DatePicker
            aria-label="Date de début de la mission"
            locale={frFR}
            popupClassName="contractDateCalendar"
            onChange={value => selectStartDate(value?.toDate() || null)}
            value={contract.startDate ? dayjs(contract.startDate).locale("fr") : null}
            className="contractDateField mt-2 h-11 w-full"
            format="DD/MM/YYYY"
            placeholder="Date de début de la mission"
          />
        </label>
        {finiteTerm && <label className="block text-sm font-medium text-slate-700">
          Fin de mission
          <DatePicker
            aria-label="Date de fin de la mission"
            locale={frFR}
            popupClassName="contractDateCalendar"
            onChange={value => selectEndDate(value?.toDate() || null)}
            value={contract.endDate ? dayjs(contract.endDate).locale("fr") : null}
            className="contractDateField mt-2 h-11 w-full"
            format="DD/MM/YYYY"
            placeholder="Date de fin de la mission"
          />
        </label>}
      </div>

      {showHours && <div className="my-4 grid gap-3 sm:grid-cols-2">
        {[["startHour", "Heure de début"], ["endHour", "Heure de fin"]].map(([key, label]) => (
          <label key={key} className="block text-sm font-medium text-slate-700">
            {label}
            <input lang="fr-FR"
              type="time"
              aria-label={label}
              step="60"
              value={contract[key] && dayjs(contract[key]).isValid() ? dayjs(contract[key]).format("HH:mm") : ""}
              onChange={event => {
                const value = event.target.value;
                setContract(current => {
                  if (!value) return {...current, [key]: null};
                  if (!/^([01]\d|2[0-3]):[0-5]\d$/.test(value)) return current;
                  const [hour, minute] = value.split(":").map(Number);
                  const base = current[key] || current.startDate || new Date();
                  return {...current, [key]: dayjs(base).hour(hour).minute(minute).second(0).millisecond(0).toDate()};
                });
              }}
              className="mt-2 h-11 w-full rounded-lg border border-slate-300 bg-white px-3 text-base text-slate-900 focus:border-slate-500 focus:outline-none focus:ring-2 focus:ring-slate-200"
            />
          </label>
        ))}
      </div>}
      {showHours && <div>
        <Input
          onChange={(e) =>
            setContract({ ...contract, nbHeureHebdo: e.target.value })
          }
          value={contract.nbHeureHebdo ? `${contract.nbHeureHebdo}` : null}
          className="rounded-md bcontract bcontract-gray-300 mb-2 mt-3"
          placeholder="Nombre heures hebdomadaire"
        />
      </div>}
    </div>
  );
};

export default CreateContractDate;
